import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchApiPut } from "../../../utils";
import { TtOrderMetadata, UpsertOrderMetadataRequest, UpsertOrderMetadataV2Request } from "./types";

function invalidateMetadataQueries(queryClient: ReturnType<typeof useQueryClient>) {
    // Invalidate staged events to refresh metadata association status
    queryClient.invalidateQueries({ queryKey: ["risk", "brokerage", "tt", "staged"] });
    // Also invalidate snapshots in case they need refresh
    queryClient.invalidateQueries({ queryKey: ["risk", "brokerage", "tt", "snapshots"] });
    queryClient.invalidateQueries({ queryKey: ["risk", "client_positions"] });
    // v2 caches
    queryClient.invalidateQueries({ queryKey: ["risk", "brokerage", "tt", "v2", "needs-attention"] });
    queryClient.invalidateQueries({ queryKey: ["risk", "brokerage", "tt", "v2", "detail"] });
    queryClient.invalidateQueries({ queryKey: ["risk", "brokerage", "tt", "v2", "active-orders"] });
}

export function useUpsertOrderMetadata() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (data: UpsertOrderMetadataRequest) => {
            const result = await fetchApiPut<{ metadata: TtOrderMetadata }>(
                "/brokerage/tt/events/orders/metadata/upsert",
                data
            );
            return result;
        },
        onSuccess: () => {
            invalidateMetadataQueries(queryClient);
        },
    });
}

export function useUpsertOrderMetadataV2() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (data: UpsertOrderMetadataV2Request) => {
            const result = await fetchApiPut<{ metadata: TtOrderMetadata }>(
                "/brokerage/tt/events/orders/metadata/upsert/v2",
                data
            );
            return result;
        },
        onSuccess: () => {
            invalidateMetadataQueries(queryClient);
        },
    });
}
